import { render, staticRenderFns } from "./SveiMappaComponent.vue?vue&type=template&id=2ad77f42"
import script from "./SveiMappaComponent.vue?vue&type=script&lang=js"
export * from "./SveiMappaComponent.vue?vue&type=script&lang=js"
import style0 from "./SveiMappaComponent.vue?vue&type=style&index=0&id=2ad77f42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports